import { StatusLabel } from 'components/common-form/sidePanel/status/initialized/StatusLabel';
import { FC } from 'react';

export const Initialized: FC = () => <StatusLabel labelKey="addon.sidePanel.status.notready" color="secondary" />;
Initialized.displayName = 'Initialized';
